import { render, staticRenderFns } from "./ValenceOfVertexForm.vue?vue&type=template&id=a955a852"
import script from "./ValenceOfVertexForm.vue?vue&type=script&lang=js"
export * from "./ValenceOfVertexForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports